// extracted by mini-css-extract-plugin
module.exports = {"gridSection":"Grid_gridSection__Mh71J","item":"Grid_item__qugu8","lastItemSpan":"Grid_lastItemSpan__yigtd","separator":"Grid_separator__s79nH","grid":"Grid_grid__JenOl"};